import MapControlPopover from '../MapControlPopover';

import CircleToolIcon from 'components/icons/CircleToolIcon';
import PolygonIcon from 'components/icons/PolygonIcon';

import useTranslation from './hooks/useTranslation';

import { DISPLAY_ICON_TEST_ID, DRAWING_TOOL, LABEL_ICON_TEST_ID, TEST_ID } from './constants';
import type { DrawingToolIcons, DrawingToolLabels, Props } from './types';

const DRAWING_TOOL_ICON: DrawingToolIcons = {
    [DRAWING_TOOL.CIRCLE]: CircleToolIcon,
    [DRAWING_TOOL.POLYGON]: PolygonIcon
};

const DrawingToolDropdown = ({ drawingTool, onDrawingToolChange, testId = TEST_ID }: Props) => {
    const { CIRCLE, POLYGON } = useTranslation();

    const Icon = DRAWING_TOOL_ICON[drawingTool];

    const drawingToolLabels: DrawingToolLabels = {
        [DRAWING_TOOL.CIRCLE]: CIRCLE,
        [DRAWING_TOOL.POLYGON]: POLYGON
    };

    const options = [
        { label: CIRCLE, value: DRAWING_TOOL.CIRCLE },
        { label: POLYGON, value: DRAWING_TOOL.POLYGON }
    ];

    return (
        <MapControlPopover
            displayText={
                <>
                    <Icon testId={LABEL_ICON_TEST_ID} />

                    {drawingToolLabels[drawingTool]}
                </>
            }
            displayIcon={<Icon testId={DISPLAY_ICON_TEST_ID} />}
            onChange={onDrawingToolChange}
            options={options}
            testId={testId}
            value={drawingTool}
        />
    );
};

export default DrawingToolDropdown;
